<template>
    <div class="form-input">
        <label v-if="label !== ''">{{ label }} <span v-if="required" class="required">*</span></label>
        <div class="input">
            <input type="password" :placeholder="placeholder" :value="value" @input="handleInput" :readonly="readonly" @change="change" ref="input">
            <div class="after" v-if="after !== ''">{{ after }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "input-password",
    props:{
        value:{type:[String,Number]},
        label:String,
        placeholder:String,
        after:{type:String,default:''},
        required:Boolean,
        readonly:Boolean,
    },
    methods:{
        handleInput(e){
            this.$emit("input",e.target.value)
        },
        change(e){
            this.$emit("change",e.target.value)
        }
    }
}
</script>